import React, { useState, useEffect, useCallback, useRef } from 'react'
import { motion } from "framer-motion";
import SlideUpOnView from "../components/SlideUpSection.jsx";
import Particles from "../components/Particles.jsx";
import uiux from "../assets/ui_ux_home1.jpg";
import software_home from "../assets/software_home.jpg";
import marketing from "../assets/marketing_home.jpg";
import lastimage from "../assets/homepage_lastimage.jpg";
import { FaRocket, FaPencilRuler, FaEye, FaCode, FaPalette, FaMagic, FaStar } from 'react-icons/fa';
import favicon from "../assets/favicon.ico";
import { Helmet } from 'react-helmet';
import SchemaMarkupComponent from "../components/SchemaMarkupComponent.jsx";
import { useNavigate } from 'react-router-dom';
import ct_logo from "./../assets/ct_logo.jpg";
import svddt_logo from "./../assets/svddt.jpg";
import rr_logo from "./../assets/ruralriselogo.png";
import cesileiosha_logo from "./../assets/cesileiosha_logo.png";

const text = "WELCOME TO TES";

const Home = () => {
  const navigate = useNavigate();
  const metaUrl = "https://www.techecosolution.in/";
  const currentDate = new Date().toISOString();
  
  const services = [
    { 
      title: "UI/UX Design", 
      image: uiux,
      description: "Professional UI/UX design services for modern web applications"
    },
    { 
      title: "Web Development", 
      image: software_home,
      description: "Full-stack web development solutions using latest technologies"
    },
    { 
      title: "Digital Marketing", 
      image: marketing,
      description: "Complete digital marketing and SEO services to grow your business"
    },
  ];

  useEffect(() => {
    // Enhanced SEO meta tags
    document.title = "TES | Best Web Development & Digital Marketing Services in India | Techecosolution";
    
    // Meta description
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Techecosolution (TES) - India's leading web development, software development & digital marketing agency. Expert UI/UX design, responsive websites, SEO services & digital solutions. Serving Bangalore & across India. Get quote now!"
      );
    }

    // Meta keywords
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "web development India, software development Bangalore, digital marketing services, SEO services India, UI/UX design, responsive website design, Techecosolution, TES, web development company, digital marketing agency, software development services"
      );
    }

    // Robots meta tag
    let robotsMeta = document.querySelector("meta[name='robots']");
    if (!robotsMeta) {
      robotsMeta = document.createElement("meta");
      robotsMeta.setAttribute("name", "robots");
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute("content", "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");

    // Author meta tag
    let authorMeta = document.querySelector("meta[name='author']");
    if (!authorMeta) {
      authorMeta = document.createElement("meta");
      authorMeta.setAttribute("name", "author");
      document.head.appendChild(authorMeta);
    }
    authorMeta.setAttribute("content", "Techecosolution Team");

    // Canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", metaUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", metaUrl);
      document.head.appendChild(canonicalLink);
    }

    // Hreflang attributes for different languages/regions
    const hreflangs = [
      { lang: "en", region: "in", url: metaUrl },
      { lang: "en", region: "us", url: metaUrl },
      { lang: "en", region: "gb", url: metaUrl },
      { lang: "x-default", region: "", url: metaUrl }
    ];

    // Remove existing hreflang links
    const existingHreflangs = document.querySelectorAll("link[hreflang]");
    existingHreflangs.forEach(link => link.remove());

    // Add new hreflang links
    hreflangs.forEach(({ lang, region, url }) => {
      const hreflangLink = document.createElement("link");
      hreflangLink.setAttribute("rel", "alternate");
      hreflangLink.setAttribute("hreflang", region ? `${lang}-${region}` : lang);
      hreflangLink.setAttribute("href", url);
      document.head.appendChild(hreflangLink);
    });

    // Favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Apple touch icon
    let appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement("link");
      appleTouchIcon.setAttribute("rel", "apple-touch-icon");
      appleTouchIcon.setAttribute("sizes", "180x180");
      appleTouchIcon.setAttribute("href", favicon);
      document.head.appendChild(appleTouchIcon);
    }

    // Preconnect to external domains
    const preconnectDomains = [
      "https://fonts.googleapis.com",
      "https://fonts.gstatic.com",
      "https://www.google-analytics.com"
    ];

    preconnectDomains.forEach(domain => {
      let preconnectLink = document.querySelector(`link[href="${domain}"]`);
      if (!preconnectLink) {
        preconnectLink = document.createElement("link");
        preconnectLink.setAttribute("rel", "preconnect");
        preconnectLink.setAttribute("href", domain);
        document.head.appendChild(preconnectLink);
      }
    });

    // DNS prefetch for performance
    const dnsPrefetchDomains = [
      "//www.googletagmanager.com",
      "//connect.facebook.net"
    ];

    dnsPrefetchDomains.forEach(domain => {
      let dnsPrefetchLink = document.querySelector(`link[href="${domain}"]`);
      if (!dnsPrefetchLink) {
        dnsPrefetchLink = document.createElement("link");
        dnsPrefetchLink.setAttribute("rel", "dns-prefetch");
        dnsPrefetchLink.setAttribute("href", domain);
        document.head.appendChild(dnsPrefetchLink);
      }
    });

  }, []);

  return (
    <>
      <SchemaMarkupComponent />
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Techecosolution | TES | Best Web Development & Digital Marketing Services in India</title>
        <meta name="title" content="Techecosolution | TES | Best Web Development & Digital Marketing Services in India" />
        <meta name="description" content="Techecosolution (TES) - India's leading web development, software development & digital marketing agency. Expert UI/UX design, responsive websites, SEO services & digital solutions. Serving Bangalore & across India." />
        <meta name="keywords" content="Techecosolution, TES, Techeco Solution, Techeco, web development India, software development Bangalore, digital marketing services, SEO services India, UI/UX design, responsive website design" />
        <meta name="author" content="Techecosolution Team" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />
        <meta name="distribution" content="web" />
        <meta name="rating" content="general" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Techecosolution" />
        <meta property="og:url" content={metaUrl} />
        <meta property="og:title" content="Techecosolution | TES | Best Web Development & Digital Marketing Services in India" />
        <meta property="og:description" content="Techecosolution (TES) - India's leading web development, software development & digital marketing agency. Expert solutions for your business growth." />
        <meta property="og:image" content={`${metaUrl}logo512.png`} />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
        <meta property="og:image:alt" content="Techecosolution - Web Development & Digital Marketing Services" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:locale:alternate" content="en_US" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:site" content="@techecosolution" />
        <meta property="twitter:creator" content="@techecosolution" />
        <meta property="twitter:url" content={metaUrl} />
        <meta property="twitter:title" content="Techecosolution | TES | Best Web Development & Digital Marketing Services in India" />
        <meta property="twitter:description" content="Techecosolution (TES) - India's leading web development, software development & digital marketing agency." />
        <meta property="twitter:image" content={`${metaUrl}logo512.png`} />
        <meta property="twitter:image:alt" content="Techecosolution Services" />

        {/* Additional SEO Meta Tags */}
        <meta name="theme-color" content="#0e5cae" />
        <meta name="msapplication-TileColor" content="#0e5cae" />
        <meta name="msapplication-config" content="/browserconfig.xml" />
        
        {/* Geo Tags */}
        <meta name="geo.region" content="IN-KA" />
        <meta name="geo.placename" content="Bangalore" />
        <meta name="geo.position" content="12.9716;77.5946" />
        <meta name="ICBM" content="12.9716, 77.5946" />

        {/* Business/Organization Tags */}
        <meta name="business:contact_data:street_address" content="Bangalore, Karnataka" />
        <meta name="business:contact_data:locality" content="Bangalore" />
        <meta name="business:contact_data:region" content="Karnataka" />
        <meta name="business:contact_data:postal_code" content="560001" />
        <meta name="business:contact_data:country_name" content="India" />

        {/* Brand Recognition Tags */}
        <meta name="application-name" content="Techecosolution" />
        <meta name="apple-mobile-web-app-title" content="Techecosolution" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="mobile-web-app-capable" content="yes" />

        {/* Security Headers */}
        <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
        <meta httpEquiv="X-Frame-Options" content="DENY" />
        <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
        <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />

        {/* Additional Meta for Search Engines */}
        <meta name="publisher" content="Techecosolution" />
        <meta name="copyright" content="© 2024 Techecosolution. All rights reserved." />
        <meta name="reply-to" content="techecosolution@gmail.com" />
        <meta name="url" content={metaUrl} />
        <meta name="identifier-URL" content={metaUrl} />
        <meta name="category" content="Technology, Web Development, Digital Marketing" />
        <meta name="coverage" content="Worldwide" />
        <meta name="target" content="all" />
        <meta name="HandheldFriendly" content="True" />
        <meta name="MobileOptimized" content="320" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": metaUrl
              }
            ]
          })}
        </script>

        {/* Hreflang Tags */}
        <link rel="alternate" hreflang="en-in" href={metaUrl} />
        <link rel="alternate" hreflang="en-us" href={metaUrl} />
        <link rel="alternate" hreflang="en-gb" href={metaUrl} />
        <link rel="alternate" hreflang="x-default" href={metaUrl} />

        {/* Canonical URL */}
        <link rel="canonical" href={metaUrl} />

        {/* Favicon Links */}
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/logo192.png" />
        <link rel="icon" type="image/png" sizes="512x512" href="/logo512.png" />
        <link rel="manifest" href="/manifest.json" />

        {/* Preconnect for Performance */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="//www.google-analytics.com" />
        <link rel="dns-prefetch" href="//www.googletagmanager.com" />
        <link rel="dns-prefetch" href="//connect.facebook.net" />
      </Helmet>

      <div className="w-full min-h-screen bg-black overflow-hidden flex flex-col items-center">
        {/* Full-Screen Animated Text */}
        <div className="w-full h-screen flex items-center justify-center px-4">
          <div className="absolute inset-0 z-0">
            <Particles
              config={{
                color: "#3B82F6",
                density: 0.4,
                lineLinked: true,
                moveSpeed: 1.5,
                size: 2,
                opacity: 0.4,
              }}
            />
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="text-black text-center text-3xl sm:text-5xl md:text-6xl lg:text-9xl font-bold flex flex-wrap justify-center font-poppins">
              {text.split(" ").map((word, wordIndex) => (
                <div key={wordIndex} className="flex mr-3 sm:mr-5">
                  {word.split("").map((char, charIndex) => {
                    let charColor = "text-white";
                    if (word === "TES") {
                      if (char === "T" || char === "E") charColor = "text-[#0e5cae]";
                      if (char === "S") charColor = "text-[#b8c1d0]";
                    }

                    return (
                      <motion.span
                        key={charIndex}
                        className={`${charColor} tracking-wider drop-shadow-[0_0_10px_rgba(0,0,0,0.7)]`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          delay: wordIndex * 0.15 + charIndex * 0.08,
                          duration: 0.3,
                        }}
                      >
                        {char}
                      </motion.span>
                    );
                  })}
                </div>
              ))}
            </div>
            <p className="mt-32 max-w-6xl text-base sm:text-lg md:text-xl text-white font-light px-4 text-center">
              🚀 From custom websites and mobile applications to branding, hosting, and complete IT support, TES covers it all.
              <br />
              💻 We deliver powerful, affordable, and scalable services that help your business grow online with ease.
            </p>
          </div>
        </div>

        {/* Hero Section */}
        <section className="flex flex-col md:flex-row items-center justify-between text-white p-6 md:p-12 rounded-lg shadow-lg mt-12" itemScope itemType="https://schema.org/WebPageElement">
          <div className="flex-shrink-0 w-full md:w-1/2 md:ml-14">
            <h1 className="text-6xl md:text-6xl font-bold leading-snug" itemProp="headline">
              Delivering tech solutions for your startups
            </h1>
          </div>

          <div className="flex flex-col items-start justify-center mt-6 md:mt-0 md:ml-12 md:mr-[-250px]">
            <p className="mt-4 w-full md:w-1/2 text-sm text-gray-300 md:ml-[-100px]" itemProp="description">
              We transform businesses of most major sectors with powerful and adaptable
              digital solutions that satisfy the needs of today.
            </p>
            <div className="mt-6 flex gap-4">
              <button 
                className="bg-blue-500 text-white py-2 px-4 rounded-lg font-semibold shadow-md hover:bg-blue-600 transition-all"
                onClick={() => navigate('/contact-tes')}
                aria-label="Contact us for web development services"
              >
                Work With Us
              </button>
            </div>
          </div>
        </section>

        {/* Hero Image */}
        <div className="flex-shrink-0 w-full md:w-5/6">
          <img
            src={lastimage}
            alt="Professional web development and digital marketing solutions by Techecosolution"
            className="w-full h-auto rounded-lg rounded-[30px] mb-10"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' }}
            loading="eager"
            itemProp="image"
          />
        </div>

        {/* Services Section */}
        <section className="text-white w-full flex flex-col items-center px-6 sm:px-12 md:px-20 py-12" itemScope itemType="https://schema.org/ItemList">
          <div className="w-full flex flex-col md:flex-row items-center justify-center gap-10">
            <h2 className="text-xl md:text-4xl font-semibold text-center md:text-left w-full md:w-2/5 break-words leading-snug" itemProp="name">
              <span className="text-blue-500">TES</span> offers awesome services
              to give you success.
            </h2>
            <SlideUpOnView>
              <div className="flex flex-wrap justify-center w-full gap-10">
                {services.map((service, index) => (
                  <article
                    key={index}
                    className={`relative bg-gray-800 p-6 rounded-2xl w-64 shadow-lg transition-all duration-300 ease-in-out hover:shadow-[0_0_25px_rgba(0,183,255,0.8)] ${
                      index % 2 === 0 ? "md:-translate-y-8" : "md:translate-y-8"
                    }`}
                    style={{
                      backgroundColor: "rgba(0, 183, 255, 0.2)",
                    }}
                    itemScope 
                    itemType="https://schema.org/Service"
                    itemProp="itemListElement"
                  >
                    <img
                      src={service.image}
                      alt={`${service.title} services by Techecosolution`}
                      className="w-full h-40 object-cover rounded-lg border-none"
                      loading="lazy"
                      itemProp="image"
                    />
                    <div className="absolute top-2 left-2 bg-blue-400 h-3 w-3 rounded-full"></div>
                    <h3 className="text-xl font-bold mt-4" itemProp="name">{service.title}</h3>
                    <meta itemProp="description" content={service.description} />
                  </article>
                ))}
              </div>
            </SlideUpOnView>
          </div>

          <div className="mt-12 w-full flex justify-center px-4 sm:px-10 md:px-32">
            <p className="text-gray-300 text-center max-w-4xl text-xl md:text-2xl font-semibold">
              We deliver the best problem-solving solutions for our clients and
              provide the finest finishing products in the present and upcoming
              future.
            </p>
          </div>
        </section>

        {/* Why Techecosolution Section */}
        <section className="relative p-8 md:p-16 overflow-hidden bg-gradient-to-br from-black via-gray-900 to-black" itemScope itemType="https://schema.org/Organization">
          {/* Background decorative elements */}
          <div className="absolute inset-0 overflow-hidden opacity-20">
            {[...Array(3)].map((_, i) => (
              <motion.div
                key={`bg-element-${i}`}
                className="absolute rounded-full bg-blue-500/10 blur-3xl"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  width: `${Math.random() * 400 + 200}px`,
                  height: `${Math.random() * 400 + 200}px`,
                }}
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.3, 0.6, 0.3]
                }}
                transition={{
                  repeat: Infinity,
                  duration: Math.random() * 8 + 8,
                  ease: "easeInOut"
                }}
              />
            ))}
          </div>

          <div className="relative z-10 max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-12"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-white to-blue-700 bg-clip-text text-transparent" itemProp="name">
                Why Techecosolution Company?
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-700 to-white mx-auto rounded-full"></div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-white space-y-6 text-lg leading-relaxed"
              itemProp="description"
            >
              <p>
                At <span className="text-blue-700 font-semibold">Techecosolution</span>, we are proud to be recognized as a leading{' '}
                <span className="text-white font-medium">Digital Marketing Agency in Bangalore</span>, providing tailored strategies that help businesses thrive in the evolving digital era. With a strong foundation in the{' '}
                <span className="text-white font-medium">evolution of digitalization</span>, we've emerged as a{' '}
                <span className="text-white font-medium">results-driven digital marketing agency</span> trusted by startups, SMEs, and enterprises across India and globally.
              </p>

              <p>
                As one of the <span className="text-white font-medium">top Digital Marketing agencies</span>, we deliver a full suite of{' '}
                <span className="text-white font-medium">Digital Marketing services</span>, including SEO, PPC, social media marketing, content creation, and more. If you're looking for the{' '}
                <span className="text-white font-medium">Top Digital Marketing Agency in Bangalore</span>, look no further—we combine innovation with proven strategies to{' '}
                <span className="text-white font-medium">boost business growth</span>.
              </p>

              <p>
                Techecosolution is not just another name among <span className="text-white font-medium">Digital Marketing Companies</span>—we are a partner in your growth. Ranked among the{' '}
                <span className="text-white font-medium">top SEO companies in the world</span>, we are known as the{' '}
                <span className="text-white font-medium">Best SEO Agency in Bangalore</span>, offering ROI-focused strategies tailored to your industry. Our global reputation as the{' '}
                <span className="text-white font-medium">Best SEO Agency</span> is built on transparency, performance, and consistency. Whether you need local SEO or global outreach, we offer the{' '}
                <span className="text-white font-medium">best SEO services in Bangalore</span> and extend the same quality as we{' '}
                <span className="text-white font-medium">offer the best SEO services globally</span>.
              </p>

              <p>
                Our capabilities go beyond marketing—we are a full-stack{' '}
                <span className="text-white font-medium">website designing and development company in Bangalore</span> and India. Our in-house team of expert{' '}
                <span className="text-white font-medium">Website Designers</span>,{' '}
                <span className="text-white font-medium">Website Developers in Bangalore TES</span>, and developers provide complete{' '}
                <span className="text-white font-medium">Website Design & Development</span>, backed by intuitive{' '}
                <span className="text-white font-medium">UI/UX Design</span>. As a trusted{' '}
                <span className="text-white font-medium">website design and development near you</span>, we ensure digital assets that are visually stunning and functionally powerful.
              </p>

              <p>
                Wondering, <span className="text-white font-medium">What is Web Development?</span> At Techecosolution, it means bringing together creativity, coding, and strategy to build future-ready digital experiences. As a premium{' '}
                <span className="text-white font-medium">website development company in Bangalore, India</span>, and a reputed{' '}
                <span className="text-white font-medium">website designing and development company in global</span> markets, we specialize in responsive and SEO-friendly solutions.
              </p>

              <p>
                Our <span className="text-white font-medium">UI/UX Design Specialization TES</span> focuses on delivering seamless user experiences. Being a{' '}
                <span className="text-white font-medium">Global UX/UI Design Company</span>, and listed among the{' '}
                <span className="text-white font-medium">Top UI/UX Design Companies in Bengaluru TES</span>, we are known for our creative design thinking and flawless interfaces. Our{' '}
                <span className="text-white font-medium">UI UX Design Services Techecosolution TES</span> ensure that every product is optimized for user satisfaction. As a{' '}
                <span className="text-white font-medium">UI UX User Experience Design Company</span>, we craft designs that convert, making us the go-to{' '}
                <span className="text-white font-medium">Global UX Design Company | TES</span>.
              </p>

              <p>
                If you're looking for a <span className="text-white font-medium">UI UX Design Agency in India</span> that delivers design-led growth, Techecosolution is your answer. With a proven track record, expert teams, and industry-leading tools, we help your brand get noticed and scale faster.
              </p>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="text-center mt-12 p-8 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl border border-blue-500/20"
              >
                <p className="text-2xl font-bold text-white mb-4">
                  Choose <span className="text-blue-700">Techecosolution</span> – the digital growth partner your business needs.
                </p>
                <motion.button
                  className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-8 rounded-full font-semibold shadow-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate('/contact-tes')}
                  aria-label="Get started with Techecosolution services"
                >
                  Get Started Today
                </motion.button>
              </motion.div>
            </motion.div>

            {/* Floating icons for visual appeal */}
            {[
              { icon: <FaRocket />, delay: 0.2 },
              { icon: <FaPalette />, delay: 0.4 },
              { icon: <FaCode />, delay: 0.6 },
              { icon: <FaEye />, delay: 0.8 }
            ].map((item, i) => (
              <motion.div
                key={`floating-icon-${i}`}
                className="absolute text-blue-400/30 text-2xl"
                style={{
                  top: `${20 + i * 20}%`,
                  left: `${10 + i * 20}%`,
                }}
                animate={{
                  y: [0, -20, 0],
                  rotate: [0, 10, -10, 0],
                  opacity: [0.3, 0.6, 0.3]
                }}
                transition={{
                  repeat: Infinity,
                  duration: 4 + i,
                  delay: item.delay,
                  ease: "easeInOut"
                }}
              >
                {item.icon}
              </motion.div>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="relative p-8 md:p-16 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900" itemScope itemType="https://schema.org/FAQPage">
          {/* Background decorative elements */}
          <div className="absolute inset-0 overflow-hidden opacity-10">
            {[...Array(4)].map((_, i) => (
              <motion.div
                key={`faq-bg-${i}`}
                className="absolute rounded-full bg-purple-500/20 blur-3xl"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  width: `${Math.random() * 300 + 150}px`,
                  height: `${Math.random() * 300 + 150}px`,
                }}
                animate={{
                  scale: [1, 1.3, 1],
                  opacity: [0.2, 0.5, 0.2]
                }}
                transition={{
                  repeat: Infinity,
                  duration: Math.random() * 10 + 10,
                  ease: "easeInOut"
                }}
              />
            ))}
          </div>

          <div className="relative z-10 max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-white to-blue-700 bg-clip-text text-transparent">
                FAQs – Why Choose Techecosolution?
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-700 to-white mx-auto rounded-full"></div>
              <p className="text-gray-400 mt-6 text-lg">
                Get answers to the most common questions about our services
              </p>
            </motion.div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {[
                {
                  question: "Why is Techecosolution considered the leading Digital Marketing Agency in Bangalore?",
                  answer: "Techecosolution is known as the Top Digital Marketing Agency in Bangalore because we deliver data-driven, performance-focused strategies that align with your business goals. Our expertise in Digital Marketing services, Internet marketing service, and campaign optimization positions us as one of the best Digital Marketing agencies in India."
                },
                {
                  question: "What sets your SEO services apart from other Digital Marketing Companies?",
                  answer: "As the Best SEO Agency in Bangalore, we use advanced tools, keyword targeting, competitor analysis, and ethical SEO techniques. Globally recognized as one of the top SEO companies in the world, we offer the best SEO services in Bangalore and deliver scalable results across industries, both locally and internationally."
                },
                {
                  question: "Do you only provide Digital Marketing Services or more?",
                  answer: "Beyond being a results-driven digital marketing agency, we're also a full-fledged website designing and development company in Bangalore and across India. We provide end-to-end Website Design & Development, UX/UI Design, and custom tech solutions tailored to your needs."
                },
                {
                  question: "What is the importance of Web Development in digital growth?",
                  answer: "What is Web Development? It's the process of building websites or web applications using front-end and back-end technologies. As a trusted website development company in Bangalore, India, Techecosolution delivers responsive, secure, and scalable web solutions for global and local brands."
                },
                {
                  question: "Are your Website Designers and developers based in India?",
                  answer: "Yes. We are proud to have highly skilled Website Designers and Website Developers in Bangalore TES. Whether you need a website design and development near you, or remote teams, our solutions ensure brand consistency and top-tier quality."
                },
                {
                  question: "What makes your UI/UX Design Services different?",
                  answer: "Our UI UX Design Services Techecosolution TES are research-backed, user-centric, and conversion-focused. We are a top-rated UI UX Design Agency in India, recognized as a Global UX Design Company | TES. We bring the best practices of the UI UX User Experience Design Company model into every project."
                },
                {
                  question: "Do you work with international clients?",
                  answer: "Absolutely. As a website designing and development company in global markets and a Global UX/UI Design Company, we serve clients across industries in the U.S., U.K., UAE, Australia, and more. We offer the best SEO services in global markets, helping brands boost business growth beyond borders."
                },
                {
                  question: "How can I hire your team for a project?",
                  answer: "You can request a free consultation on our website or contact us directly. Whether you need a Web Designer, SEO expert, or UI/UX Design Specialization TES team—we're here to deliver high-quality work with measurable results."
                },
                {
                  question: "What industries do you serve?",
                  answer: "As a Top Digital Marketing Agency in Bangalore and UI UX Design Agency in India, we serve industries like healthcare, education, real estate, e-commerce, SaaS, finance, travel, and tech startups. Our customized Digital Marketing services are designed to fit each industry's needs."
                },
                {
                  question: "Is Techecosolution a good choice for startups?",
                  answer: "Yes. Startups benefit greatly from our flexible, scalable strategies. We are not just a website builder TES or design firm—we're your growth partner. With strong roots in the evolution of digitalization, we support startup journeys with SEO, branding, web development, and UI/UX excellence."
                }
              ].map((faq, index) => (
                <motion.div
                  key={`faq-${index}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="group"
                  itemScope
                  itemType="https://schema.org/Question"
                  itemProp="mainEntity"
                >
                  <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/30 rounded-2xl p-6 hover:border-blue-500/30 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/10">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                        {index + 1}
                      </div>
                      <div className="flex-1">
                        <h3 
                          className="text-lg font-semibold text-white mb-3 group-hover:text-blue-400 transition-colors duration-300"
                          itemProp="name"
                        >
                          {faq.question}
                        </h3>
                        <div 
                          className="text-gray-300 leading-relaxed"
                          itemScope
                          itemType="https://schema.org/Answer"
                          itemProp="acceptedAnswer"
                        >
                          <div itemProp="text">
                            {faq.answer.split(/(\b(?:Digital Marketing Agency in Bangalore|Top Digital Marketing Agency|Best SEO Agency|website designing and development company|UI UX Design Services|Global UX Design Company|Website Developers in Bangalore TES|best SEO services)\b)/gi).map((part, i) => {
                              const keywords = [
                                // 'Digital Marketing Agency in Bangalore',
                                // 'Top Digital Marketing Agency',
                                // 'Best SEO Agency',
                                // 'website designing and development company',
                                // 'UI UX Design Services',
                                // 'Global UX Design Company',
                                // 'Website Developers in Bangalore TES',
                                // 'best SEO services'
                              ];
                              
                              if (keywords.some(keyword => keyword.toLowerCase() === part.toLowerCase())) {
                                return (
                                  <span key={i} className="text-blue-400 font-medium">
                                    {part}
                                  </span>
                                );
                              }
                              return part;
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Call to Action */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-center mt-16 p-8 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl border border-blue-500/20"
            >
              <h3 className="text-2xl font-bold text-white mb-4">
                Still have questions? We're here to help!
              </h3>
              <p className="text-gray-300 mb-6">
                Get in touch with our experts for personalized solutions
              </p>
              <motion.button
                className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-8 rounded-full font-semibold shadow-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate('/contact-tes')}
                aria-label="Contact Techecosolution for more information"
              >
                Contact Us Today
              </motion.button>
            </motion.div>
          </div>
        </section>

        {/* Design Process Section */}
        <section className="relative p-8 overflow-hidden" itemScope itemType="https://schema.org/HowTo">
          <h3 className="text-3xl font-bold mb-12 text-center" itemProp="name">Our Design Process</h3>           
          <div className="flex flex-wrap justify-center">
            {[
              { icon: <FaEye />, title: "Research", description: "Understanding user needs" },
              { icon: <FaPencilRuler />, title: "Wireframing", description: "Structure & layout" },
              { icon: <FaPalette />, title: "Visual Design", description: "Aesthetics & branding" },
              { icon: <FaCode />, title: "Development", description: "Bringing designs to life" },
              { icon: <FaMagic />, title: "Testing", description: "Refining the experience" },
              { icon: <FaRocket />, title: "Deployment", description: "Enhancing the experience" }
            ].map((step, i) => (
              <motion.div
                key={`process-${i}`}
                className="w-full sm:w-1/2 lg:w-1/6 px-4 mb-8 relative"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                itemScope
                itemType="https://schema.org/HowToStep"
                itemProp="step"
              >
                {/* Connecting line */}
                {i < 6 && (
                  <motion.div 
                    className="absolute top-12 right-0 w-full h-px bg-blue-500/60 hidden lg:block"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.2 + 0.5, duration: 0.5 }}
                  />
                )}          
                
                <div className="flex justify-center mb-4">
                  <motion.div
                    className="relative w-24 h-24 rounded-full border border-blue-500 flex items-center justify-center"
                    whileHover={{ scale: 1.1 }}
                    animate={{ 
                      boxShadow: ['0 0 0px rgba(139, 92, 246, 0.3)', '0 0 20px rgba(139, 92, 246, 0.7)', '0 0 0px rgba(139, 92, 246, 0.3)']
                    }}
                    transition={{ 
                      boxShadow: { repeat: Infinity, duration: 2 },
                    }}
                  >
                    <div className="text-3xl text-blue-500">{step.icon}</div>              
                    <motion.div 
                      className="absolute -inset-1 rounded-full border border-blue-500/50"
                      animate={{ scale: [1, 1.2, 1] }}
                      transition={{ repeat: Infinity, duration: 3, delay: i * 0.5 }}
                    />
                  </motion.div>
                </div>
                <h4 className="text-xl font-bold mb-2 text-center" itemProp="name">{step.title}</h4>
                <p className="text-gray-400 text-center" itemProp="text">{step.description}</p>
              </motion.div>
            ))}
          </div>
          
          {/* Animated vector elements */}
          {[...Array(5)].map((_, i) => (
            <motion.div
              key={`vector-element-${i}`}
              className="absolute"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
              }}
              animate={{
                x: [0, Math.random() * 50 - 25],
                y: [0, Math.random() * 50 - 25],
                opacity: [0.3, 0.6, 0.3]
              }}
              transition={{
                repeat: Infinity,
                duration: Math.random() * 8 + 8,
                ease: "easeInOut"
              }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10">
                <circle cx="5" cy="5" r="4" fill="none" stroke="rgba(139, 92, 246, 0.5)" strokeWidth="1" />
              </svg>
            </motion.div>
          ))}
        </section>

        {/* Testimonials Section */}
        {/* <section className="container mx-auto px-4 relative z-10" itemScope itemType="https://schema.org/Organization">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-4xl font-bold mb-6">Testimonials:</h2>
            <p className="text-3xl text-blue-500 max-w-3xl mx-auto">
              Trusted by our clients
            </p>
          </motion.div>      
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: "Sarah Johnson",
                role: "CEO, TechStart",
                image: "https://randomuser.me/api/portraits/women/44.jpg",
                quote: "The UI/UX design services provided were exceptional. Our website now looks stunning and performs better than ever. Highly recommended!"
              },
              {
                name: "Michael Chen",
                role: "Marketing Director, GrowthHub",
                image: "https://randomuser.me/api/portraits/men/32.jpg",
                quote: "Working with Techecosolution transformed our e-commerce platform. The intuitive design increased our conversion rates by 45% in just two months."
              },
              {
                name: "Emily Rodriguez",
                role: "Product Manager, HealthTech",
                image: "https://randomuser.me/api/portraits/women/68.jpg",
                quote: "Their accessibility-focused approach ensured our healthcare app could be used by everyone. The attention to detail and user-centric design is impressive."
              }
            ].map((testimonial, i) => (
              <motion.div
                key={`testimonial-${i}`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.2 }}
                className="relative group"
                itemScope
                itemType="https://schema.org/Review"
                itemProp="review"
              >
                <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur opacity-0 group-hover:opacity-70 transition duration-300"></div>          
                <div className="relative bg-black border border-purple-500/30 p-8 rounded-2xl">
                  <div className="flex justify-center mb-6">
                    <div className="relative">
                      <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-purple-500">
                        <img 
                          src={testimonial.image} 
                          alt={`${testimonial.name} - ${testimonial.role}`}
                          className="w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>          
                      <motion.div 
                        className="absolute -inset-2 rounded-full blur-md z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                        animate={{ scale: [1, 1.2, 1] }}
                        transition={{ repeat: Infinity, duration: 3 }}
                        style={{
                          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.6) 0%, rgba(139, 92, 246, 0) 70%)',
                        }}
                      />
                    </div>
                  </div>
                  
                  <div className="flex justify-center mb-4" itemProp="reviewRating" itemScope itemType="https://schema.org/Rating">
                    <meta itemProp="ratingValue" content="5" />
                    <meta itemProp="bestRating" content="5" />
                    {[...Array(5)].map((_, starIndex) => (
                      <motion.div
                        key={`star-${i}-${starIndex}`}
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 + starIndex * 0.1 }}
                      >
                        <FaStar className="text-yellow-400 mx-1 text-xl" />
                      </motion.div>
                    ))}
                  </div>                  
                  
                  <p className="text-center text-gray-300 mb-4" itemProp="reviewBody">
                    "{testimonial.quote}"
                  </p>                 
                  
                  <div className="text-center" itemProp="author" itemScope itemType="https://schema.org/Person">
                    <h4 className="font-bold text-lg" itemProp="name">{testimonial.name}</h4>
                    <p className="text-purple-400" itemProp="jobTitle">{testimonial.role}</p>
                  </div>
                  
                  <meta itemProp="datePublished" content={currentDate} />
                </div>
              </motion.div>
            ))}
          </div>
        </section> */}

        {/* Our Client Projects Section */}
        <section className="relative py-16 px-8 bg-gradient-to-b from-gray-900 to-black">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Our <span className="text-blue-500">Success Stories</span>
              </h2>
              <div className="w-20 h-1 bg-blue-500 mx-auto mb-6"></div>
              <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                Trusted by leading companies worldwide. See some of our successful partnerships.
              </p>
            </motion.div>

            {/* Client Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {[
                { name: "Credible Technologies", logo: ct_logo, url: "https://www.credibletech.in/", initial: "CT", color: "bg-blue-600" },
                { name: "Sri Vijaya Durga Devi Temple", initial: "SVDDT", logo: svddt_logo, url: "https://www.srivijayadurgadevi.org/", color: "bg-green-600" },
                { name: "Rural Rise Agrinery LLP", logo: rr_logo, url: "https://www.ruralriseagrinery.com/", initial: "RRALLP", color: "bg-red-600" },
                { name: "Cesileiosha", logo: cesileiosha_logo, url: "https://www.cesileiosha.store/", initial: "CESILEIOSHA", color: "bg-yellow-600" },
              ].map((client, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="group"
                >
                  <div className="bg-gray-800 hover:bg-gray-700 rounded-xl p-6 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
                    <div className="flex flex-col items-center">
                      <div className="w-32 h-32 bg-white rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300 p-2">
                        <img
                          onClick={() => window.open(client.url, "_blank")}
                          src={client.logo}
                          alt={`${client.name} logo`}
                          className="w-full h-full object-contain"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                        <div 
                          className={`w-full h-full ${client.color} rounded-lg flex items-center justify-center`}
                          style={{ display: 'none' }}
                        >
                          <span className="text-white font-bold text-lg">
                            {client.name.charAt(0)}
                          </span>
                        </div>
                      </div>
                      <span className="text-gray-300 text-sm font-medium group-hover:text-white transition-colors text-center">
                        {client.name}
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Stats Section */}
            {/* <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
            >
              {[
                { number: "7+", label: "Projects Delivered" },
                { number: "7+", label: "Happy Clients" },
                { number: "99.9%", label: "Success Rate" }
              ].map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-blue-500 mb-2">{stat.number}</div>
                  <div className="text-gray-400">{stat.label}</div>
                </div>
              ))}
            </motion.div> */}

            {/* CTA */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="text-center"
            >
              <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-8 mt-0">
                <h3 className="text-xl font-bold text-white mb-3">
                  Ready to Start Your Project?
                </h3>
                <p className="text-gray-400 mb-6 max-w-xl mx-auto">
                  Join our list of satisfied clients and let's build something amazing together.
                </p>
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-8 rounded-lg font-semibold transition-colors duration-300"
                  onClick={() => navigate('/contact-tes')}
                >
                  Get Started
                </button>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
